import * as React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <div>
          <div className="loader"></div>
        </div>
        <div style={{ color: "black", fontWeight: "bold" }}>Please wait...</div>
      </div>
    </>
  );
};

export default Loader;
